module.exports = __webpack_public_path__ + "media/images/ep7-cindy-6278c0ce0f7d29e5d2fd906441fe067e.png";